import axios from "axios";

export const consultDoctorData = (consult_id) => {
  return axios
    .post("/fetch_consultation_doctors", consult_id)
    .then((response) => {
      // console.log(response.data);
      return response;
    });
};